<template lang="pug">
    article#curso
        Banner(:image="curso.interna", :titulo="curso.nome_curso")
        .wrapper
            Navegacao(:itensMenu="itensMenu", v-if="curso.slug")
            Conteudo(:curso_raw="curso", :itensMenu="itensMenu")
            Inscricao(:curso="curso", v-if="curso.slug")
</template>

<script>
import qs from 'qs'
import Banner from '@sections/Curso/Banner/Banner'
import Conteudo from '@sections/Curso/Conteudo/Conteudo'
import Inscricao from '@sections/Curso/Inscricao/Inscricao'
import Navegacao from '@sections/Curso/Navegacao/Navegacao'
import { alterTags } from "@/mixins/seo.js"
import { MENU_ITEMS_REFERENCE } from './Constantes'

const fael_cidade_id = document.querySelector('meta[name="fael_cidade_id"]');

export default {
    name: "view-curso",
    components: {
        Banner,
        Conteudo,
        Inscricao,
        Navegacao
    },
    data() {
        return {
            curso: {},
            params: {
                cidade: fael_cidade_id ? fael_cidade_id.getAttribute('content') : ''
            }
        }
    },
    computed: {
        itensMenu() {
            let items = []
            Object.keys(MENU_ITEMS_REFERENCE).forEach(key => {
                if (this.curso[key])
                    items.push(MENU_ITEMS_REFERENCE[key])
            })
            return items
        },
    },
    created() {
        this.loadCurso();
    },
    methods: {
        loadCurso() {
            this.$axios
                .get(`cursos/${this.$route.params.tipo}/${this.$route.params.slug}?${qs.stringify(this.params)}`)
                .then(response => {
                    this.curso = response.data;
                    this.$eventbus.$emit('curso-id-url', this.curso.curso_id);
                    this.$emit('curso-id-url',this.curso.curso_id);
                    alterTags(this.curso.seo_title, this.curso.seo_description)
                })
                .catch(error => console.log(error.response))
        }
    },
}
</script>

<style lang="stylus" scoped src="./Curso.styl"></style>
